import { Instance, types as t } from 'mobx-state-tree';

export const FileInfo = t.model('FileInfo', {
  name: t.maybeNull<any>(t.string),
  path: t.maybeNull<any>(t.string),
  url: t.maybeNull<any>(t.string),
  uploadedDate: t.maybeNull<any>(t.string),
  size: t.maybeNull(t.number),
});

export const ImageInfo = FileInfo.named('ImageInfo').props({
  alt: t.maybeNull<any>(t.string),
  caption: t.maybeNull<any>(t.string),
});

export interface ImageInfoInstance extends Instance<typeof ImageInfo> {}

export interface FileInfoInstance extends Instance<typeof FileInfo> {}

export const AbstractScript = t.model('AbstractScript', {
  audio: t.maybeNull(FileInfo),
  waveInfo: t.maybeNull<any>(t.string),
  transcript: t.maybeNull(FileInfo),
  type: t.string,
});

